import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-wellbean-login',
  templateUrl: './wellbean-login.component.html',
  styleUrls: ['../style/global.css', './wellbean-login.component.css'],
})
export class WellbeanLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}

  get isMedicalUser() {
    return this.role !== 'patient';
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get isRegisterResendable(): boolean {
    // EAJの場合は確認メール再送信させない
    if (environment.apps[this.clientId].oemConfig?.id === 'EAJ') return false;

    return true;
  }

  get isRegistable() {
    // 医療ユーザーがログインしようとしている場合は新規会員登録させない
    if (this.isMedicalUser) return false;

    // 自治体向けOEMの場合も新規会員登録させない
    if (this.isOem) return false;

    // Wellbean: 新規登録ボタンは非表示とする
    // return true;
    return false;
  }
}
